"use client";

import dynamic from "next/dynamic";

const ClientOnlyVideoAsset = dynamic(() => import("@/templates/VideoAsset"), {
  ssr: false,
  loading: () => <div className="min-h-[600px]" aria-hidden="true" />,
});

export default ClientOnlyVideoAsset;
